// extracted by mini-css-extract-plugin
export var button = "account-data-module--button--OqlNs";
export var form = "account-data-module--form--fzMHY";
export var inputEmail = "account-data-module--input-email--PXcKZ";
export var inputFirstName = "account-data-module--input-first-name--iqTgr";
export var inputLastName = "account-data-module--input-last-name--EMhUQ";
export var loading = "account-data-module--loading--INyr4";